import useSwr from 'swr';
import { SwrReturnType } from '~/models/Api';
import { VendorUser } from '~/models/VendorUser';

const paths = {
  index: '/vendors/vendor_users'
};
type TIndex = () => SwrReturnType<VendorUser[]>;

type ReturnType = {
  index: TIndex;
};

export const useVendorUsers = (): ReturnType => {
  const index: TIndex = () => {
    const { data, mutate, error } = useSwr<VendorUser[]>(paths.index);
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
